/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiUserWallCredentialsFromJSON, StreemApiUserWallCredentialsToJSON, } from './';
export function StreemApiCreateUserTokensResponseFromJSON(json) {
    return StreemApiCreateUserTokensResponseFromJSONTyped(json, false);
}
export function StreemApiCreateUserTokensResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userWallCredentials': !exists(json, 'user_wall_credentials') ? undefined : StreemApiUserWallCredentialsFromJSON(json['user_wall_credentials']),
    };
}
export function StreemApiCreateUserTokensResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_wall_credentials': StreemApiUserWallCredentialsToJSON(value.userWallCredentials),
    };
}
//# sourceMappingURL=StreemApiCreateUserTokensResponse.js.map